import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  MdLogin,
  MdOutlineAccountBalanceWallet,
  MdMenu,
  MdClose,
  MdCardMembership,
  MdDeleteOutline,
} from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import avatarImg from "../../images/shapes/Profile_Logo 1.png";
import LogoutModal from "../RetailerBusinessAgent/LogoutModal";
import AccountClosureModal from "../AccountClosureModal/AccountClosureModal";
import "../RetailerBusinessAgent/SideBar.css";

function MemberSideBar({ user }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showClosureModal, setShowClosureModal] = useState(false);

  const handleNavClick = () => {
    if (mobileOpen) {
      setMobileOpen(false);
    }
  };

  return (
    <>
      <aside className={`sidebar_container1 ${mobileOpen ? "expanded" : ""}`}>
        {/* Profile Header */}
        <div className="profile1">
          <img
            src={user?.avatar || avatarImg}
            alt="Profile"
            className="profile-img1"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = avatarImg;
            }}
          />

          <div className="profile-info1">
            <h3 className="profile-name1">{user?.firstName || "Member"}</h3>
            <p className="profile-role1">{user?.role || "Member"}</p>
          </div>

          <button
            className="sidebar-toggle"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <MdClose /> : <MdMenu />}
          </button>
        </div>

        {/* Navigation */}
        <nav className="sidebar-content">
          <ul className="menu1">
            <li>
              <NavLink
                to="/members/wallet"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdOutlineAccountBalanceWallet className="icon1" />
                Wallet
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/members/edit-profile"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <CgProfile className="icon1" />
                Edit Profile
              </NavLink>
            </li>

            {/* <li>
              <NavLink
                to="/member/card-collection"
                className={({ isActive }) =>
                  isActive ? "menu-link1 active1" : "menu-link1"
                }
                onClick={handleNavClick}
              >
                <MdCardMembership className="icon1" />
                Premium Card Collection
              </NavLink>
            </li> */}
          </ul>

          <div className="bottom-menu1">
            <hr />
            {/* <button
              className="logout-btn1 gap-1"
              style={{ color: "#dc2626", marginBottom: "8px" }}
              onClick={() => setShowClosureModal(true)}
            >
              <MdDeleteOutline className="icon1" style={{ color: "#dc2626" }} /> Forgot Me – Close My Account
            </button> */}
            <button
              className="logout-btn1"
              onClick={() => setShowLogoutModal(true)}
            >
              <MdLogin className="icon1" /> Logout
            </button>
          </div>
        </nav>
      </aside>

      {showLogoutModal && (
        <LogoutModal
          user={user}
          onClose={() => setShowLogoutModal(false)}
        />
      )}

      {showClosureModal && (
        <AccountClosureModal
          isOpen={showClosureModal}
          onClose={() => setShowClosureModal(false)}
        />
      )}
    </>
  );
}

export default React.memo(MemberSideBar);
